export const directBookingsSettingsView = {
  loading: "Einstellungen werden geladen…",

  sidebar: {
    brandTitle: "Inserate",
    brandSub: "Einstellungen",
    searchPlaceholder: "Suchen…",
    generalLabel: "Allgemein",
    servicesName: "Services und Erlebnisse",
    servicesSub: "Eine Liste fürs ganze Konto",
    promotionsName: "Angebote",
    promotionsSub: "Erstellen · Bearbeiten · Verwalten",
    globalChip: "GLOBAL",
    inactivePrefix: "Inaktiv · {type}",
    unitsCount: "{count} Einheit | {count} Einheiten",
    empty: "Keine Unterkünfte.",
    listingFallbackName: "Inserat",
  },

  status: {
    active: "Aktiv",
    inactive: "Inaktiv",
  },

  card: {
    unsavedChanges: "Nicht gespeicherte Änderungen",
  },

  share: {
    title: "Link für Direktbuchungen",
    hintPrefix: "Teilen Sie den Link für",
    hintSuffix: "um provisionsfreie Buchungen zu erhalten.",
    copyTitle: "Link kopieren",
    viewAsVisitor: "Als Besucher ansehen",
    copied: "Link kopiert.",
    copyError: "Der Link konnte nicht kopiert werden.",
    whatsappText: "Hallo 👋 Hier ist der Link zum Buchen: {link}",
  },

  savebar: {
    unsaved: "Nicht gespeicherte Änderungen",
    noChanges: "Keine ausstehenden Änderungen",
    saving: "Wird gespeichert…",
  },

  drawer: {
    close: "Schließen",
  },

  content: {
    selectListing: "Inserat auswählen",
  },

  units: {
    pickerHint: "Schalten Sie die Sichtbarkeit jeder Einheit für Direktbuchungen ein oder aus oder öffnen Sie sie, um sie einzurichten (Preise, Bilder, Beschreibung, Services und Gebühren).",
    visible: "Sichtbar",
    hidden: "Ausgeblendet",
    showTooltip: "Diese Einheit in Direktbuchungen anzeigen",
    configure: "Einrichten",
  },

  header: {
    listingSub: "Inserat · {count} Einheit · Direktbuchungen | Inserat · {count} Einheiten · Direktbuchungen",
    unitSub: "Einheit · individuelle Einrichtung",
    unitSubCoded: "Einheit {code} · individuelle Einrichtung",
    hotelSub: "Hotel / Campingplatz · Direktbuchungen",
    apartmentSub: "Wohnung / Villa · Direktbuchungen",
  },

  tabs: {
    reservations:       { label: "Sichtbarkeit des Inserats", sub: "Aktivieren und Zahlung sowie Freigabe für Direktbuchungen festlegen" },
    units_list:         { label: "Einheiten",                 sub: "Welche Einheiten buchbar sind" },
    common_images:      { label: "Gemeinschaftsbereiche",     sub: "Gemeinsame Gebäudefotos (Titelbild)" },
    rate_plans:         { label: "Preise",                    sub: "Sichtbare Tarife" },
    images:             { label: "Bilder",                    sub: "Galerie des Inserats" },
    description:        { label: "Beschreibung",              sub: "Text und Details des Inserats" },
    services:           { label: "Services",                  sub: "Services und Ausstattung" },
    promotions:         { label: "Angebote",                  sub: "Wie sie in diesem Inserat erscheinen" },
    addons:             { label: "Belegung",                  sub: "Rabatte und zusätzlicher Gast" },
    age_rules:          { label: "Gästeregeln",               sub: "Babys, Kinder und Kapazität" },
    additional_charges: { label: "Gebühren und Steuern",      sub: "MwSt., Reinigung und Gebühren" },
    web_embed:          { label: "Web-Integration",           sub: "Suchfeld auf Ihrer eigenen Website einbinden" },
  },

  save: {
    ratePlans: "Preise speichern",
    promotions: "Angebote speichern",
    addons: "Gebühren speichern",
    ageRules: "Regeln speichern",
    additionalCharges: "Gebühren und Steuern speichern",
    payments: "Zahlungen speichern",
    default: "Speichern",
  },

  types: {
    apartment: "Wohnung",
    house: "Haus",
    villa: "Villa",
    loft: "Loft",
    room: "Zimmer",
    studio: "Studio",
    cabin: "Hütte",
    hotel: "Hotel",
    hostel: "Hostel",
    camping: "Campingplatz",
  },

  toasts: {
    unitVisible: "Einheit in Direktbuchungen sichtbar.",
    unitHidden: "Einheit ausgeblendet.",
    unitUpdateError: "Die Einheit konnte nicht aktualisiert werden.",
  },

  errors: {
    noUserUuid: "Benutzer-UUID nicht gefunden.",
    loadPage: "Die Seite konnte nicht geladen werden.",
    loadContext: "Der Kontext konnte nicht geladen werden.",
    saveExec: "Das Speichern konnte nicht ausgeführt werden.",
    saveGeneric: "Speichern nicht möglich.",
  },

  misc: {
    propertyFallback: "Unterkunft {id}",
  },
};
